import React from 'react';
import {FormGroup, Input, Label} from 'reactstrap';
import { FormattedMessage } from 'react-intl';

const ReduxFormCheck: React.FC = (field: any) => (
  <FormGroup check row={false} className="mt-md-4 ms-md-3">
    <Label check>
      <Input
        {...field.input}
        type={field.type == 'radio' ? 'radio' : 'checkbox'}
        disabled={field.disabled}
      />{' '}
      {field.label && (<FormattedMessage {...field.label} />)}
    </Label>
    {field.meta.touched && field.meta.error && (
      <p className="text-danger"><FormattedMessage id={field.meta.error} /></p>
    )}
  </FormGroup>
);

export default ReduxFormCheck;
